import React from "react";
import reactDom from "react-dom";

const ModalPortal = ({ children }) => {
  return reactDom.createPortal(
    <>{children}</>,
    document.getElementById("modal"),
  );
};

export default ModalPortal;
